import React, { useState } from "react";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../store/helpers/mapState";
import { connect } from "react-redux";
import { Alert, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import OpenDocument from "helpers/openDocument";

function Login(props) {
  const { SystemLogin, errorMessage, successMessage } = props;

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const settings = secureLocalStorage.getItem("systemSettings");
  const systemSettings = JSON.parse(settings);
  const backgroundColor = systemSettings?.mainBackground ?? "bg-blueGray-800";

  return (
    <>
      {/*<Navbar transparent={false} />*/}

      <main className="overflow-hidden">
        <div className="relative flex items-center justify-center w-full h-full">
          <div className="absolute top-0 w-full h-full bg-center bg-cover"></div>

          <div className="relative container mx-auto px-0 h-full">
            <div className="flex flex-col content-center items-center justify-center h-full">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center">
                  {/* <img
                    src={ifLogoWhite}
                    alt="IF Logo"
                    className="h-16 w-auto"
                  /> */}
                  <OpenDocument
                    mimeType={"image"}
                    document={systemSettings?.logoImage}
                    downloadable={false}
                    type={"logo"}
                    imgClassName="h-16 w-auto"
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                  <div className="flex-auto px-4 lg:px-8 py-8">
                    {(errorMessage || successMessage) && (
                      <div>
                        <Alert
                          className="mb-3"
                          severity={successMessage ? "success" : "error"}
                          onClose={() => {}}
                        >
                          {successMessage ?? errorMessage}
                        </Alert>
                      </div>
                    )}
                    <form
                      action={""}
                      method={"POST"}
                      onSubmit={async (event) => {
                        event.preventDefault();
                        if (loading) return;

                        setLoading(true);
                        const data = new FormData(event.currentTarget);
                        await SystemLogin({
                          email: data.get("email"),
                          password: data.get("password"),
                        });

                        setLoading(false);
                      }}
                    >
                      {/* Form fields */}
                      <div className="relative w-full mb-3">
                        <label
                          className="text-black text-sm mb-2"
                          htmlFor="email"
                        >
                          Email
                        </label>
                        <div className="relative flex items-center mt-1">
                          <input
                            type="email"
                            required={true}
                            name="email"
                            className="border border-input px-3 py-3 pl-10 placeholder-blueGray-300 text-black bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            placeholder="Email"
                          />
                          <img
                            src={require("../../assets/img/Email.svg").default}
                            alt="Email Icon"
                            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5"
                          />
                        </div>
                      </div>

                      <div className="relative w-full mb-3">
                        <label
                          className="text-black text-sm mb-2"
                          htmlFor="password"
                        >
                          Password
                        </label>
                        <div className="relative flex items-center mt-1">
                          <input
                            type={show ? "text" : "password"}
                            required={true}
                            name="password"
                            className="border border-input px-3 py-3 pl-10 pr-10 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            placeholder="********"
                          />
                          <img
                            src={
                              require("../../assets/img/password.svg").default
                            }
                            alt="Password Icon"
                            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500"
                          />
                          <i
                            className={`far ${
                              show ? "far fa-eye" : "fa-eye-slash"
                            } absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500`}
                            title={show ? "Hide password" : "Show password"}
                            onClick={() => setShow(!show)}
                          ></i>
                        </div>
                      </div>

                      {/* Forgot Password link directly below the password field */}
                      <div className="mt-4">
                        <Link
                          to="/auth/forgot-password"
                          className="text-blue-600 text-sm"
                        >
                          Forgot password?
                        </Link>
                      </div>

                      {/* Submit Button */}
                      <div className="text-center mt-3">
                        <button
                          className={`${
                            loading ? "bg-gray-500" : backgroundColor
                          } flex justify-center text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150`}
                          type="submit"
                          disabled={loading}
                          style={{ 
                            backgroundColor: "#526680"
                          }}
                        >
                          LOGIN{" "}
                          {loading ? (
                            <CircularProgress size={20} className={"ml-3"} />
                          ) : null}
                        </button>
                      </div>
                    </form>

                    <div className="mt-3 text-center">
                      <span className="text-gray-500 text-sm">
                        Can't access?{" "}
                      </span>
                      <a
                        href="https://www.qtglobal.rw/contact"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 text-sm"
                      >
                        Contact Admin
                      </a>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap mt-6 relative">
                  <div className="w-1/2">
                    <a
                      href="#create-account"
                      onClick={(e) => e.preventDefault()}
                      className="text-blueGray-200"
                    >
                      {/* <small>Create new account</small> */}
                    </a>
                  </div>
                  <div className="w-1/2 text-right">
                    {/* <Link to="/auth/register" className="text-blueGray-200">*/}
                    {/*  <small>Create new account</small>*/}
                    {/*</Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
